import React from "react";
import { withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import withFieldsCheck from "@clarion/foundation/dist/Helpers/containers/WithFieldsCheck/index";
import { BOOST } from "@clarion/foundation/dist/Settings/constants";
import BoostChatbot from "./BoostChatbot";
import CopilotChatbot from "./CopilotChatbot";
const Chatbot = ({
  sitecoreContext,
  ...props
}) => {
  const chatClient = sitecoreContext.route.fields.ChatClient?.value;
  const copilotChatAgentEnabled = sitecoreContext.chatbotSetting?.copilotChatAgentEnabled || false;
  if (copilotChatAgentEnabled) {
    return /*#__PURE__*/React.createElement(CopilotChatbot, props);
  }
  if (!chatClient) {
    return null;
  }
  if (chatClient === BOOST) {
    return /*#__PURE__*/React.createElement(BoostChatbot, props);
  }
  return null;
};
const ChatbotWithFieldsCheck = withFieldsCheck(Chatbot, {
  routeField: "ChatClient"
});
export default withSitecoreContext()(ChatbotWithFieldsCheck);